export const ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER = "orderAttributes";

export const FISCAL_CODE_ATTRIBUTE_KEY = "fiscal_code";
